import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import reducers from './reducers'

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const store = createStore(reducers, compose(applyMiddleware(thunk)))

const root = createRoot(document.getElementById("root"));
// require('dotenv').config()

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
